import React from 'react'
import { Link } from 'react-router-dom'
import Layout from '../layout/Layout'
import ServicesSection from '../components/Services'
import SEO from '../components/SEO'

function Services() {
  return (
    <Layout>
      <SEO
        title="Technology Services | Papreja Tech Solutions"
        description="Explore practical technology, design, and engineering services from Papreja Tech Solutions."
        path="/services"
      />
      <section className="relative overflow-hidden bg-[#071a3d] text-white">
        <div className="absolute inset-0 bg-gradient-to-br from-[#071a3d] via-[#0b2d63] to-[#123f7a]" />
        <div className="relative mx-auto grid max-w-7xl gap-8 px-5 py-14 sm:px-8 sm:py-20 lg:grid-cols-[1.2fr_0.8fr] lg:items-end lg:px-10">
          <div className="max-w-2xl">
            <p className="text-sm font-bold uppercase tracking-[0.2em] text-cyan-300">Our services</p>
            <h1 className="mt-4 text-4xl font-black leading-tight tracking-tight sm:text-5xl">The right technology for your next move.</h1>
            <p className="mt-5 max-w-xl text-base leading-7 text-blue-100 sm:text-lg">
              We combine practical advice, thoughtful design, and dependable engineering to help your business work smarter and grow with confidence.
            </p>
            <Link to="/contact" className="mt-7 inline-flex rounded-lg bg-cyan-400 px-5 py-3 text-sm font-bold text-[#071a3d] transition hover:-translate-y-0.5 hover:bg-cyan-300">
              Talk about your goals <span className="ml-2" aria-hidden="true">-&gt;</span>
            </Link>
          </div>
          <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-1">
            <div className="rounded-2xl border border-white/15 bg-white/10 p-5 backdrop-blur-sm">
              <p className="text-lg font-bold">Start with clarity</p>
              <p className="mt-2 text-sm leading-6 text-blue-100">We understand the challenge before recommending the solution.</p>
            </div>
            <div className="rounded-2xl border border-white/15 bg-white/10 p-5 backdrop-blur-sm">
              <p className="text-lg font-bold">Build for progress</p>
              <p className="mt-2 text-sm leading-6 text-blue-100">Every project is designed to be useful today and ready for tomorrow.</p>
            </div>
          </div>
        </div>
      </section>
      <ServicesSection />
      <section className="relative overflow-hidden bg-slate-100 px-5 py-14 dark:bg-slate-950 sm:px-8 sm:py-16 lg:px-10">
        <div className="relative mx-auto flex max-w-7xl flex-col items-start justify-between gap-6 overflow-hidden rounded-2xl bg-gradient-to-r from-[#071a3d] via-[#0b2d63] to-[#123f7a] px-6 py-8 text-white shadow-xl shadow-blue-950/15 sm:px-10 sm:py-10 md:flex-row md:items-center">
          <div className="relative max-w-2xl">
            <p className="text-sm font-bold uppercase tracking-[0.2em] text-cyan-300">Ready when you are</p>
            <h2 className="mt-3 text-2xl font-black tracking-tight sm:text-3xl">Have a challenge in mind?</h2>
            <p className="mt-3 text-sm leading-6 text-blue-100 sm:text-base">Let&apos;s talk through your goals and find a practical way to move forward.</p>
          </div>
          <Link to="/contact" className="relative shrink-0 rounded-lg bg-cyan-400 px-5 py-3 text-sm font-bold text-[#071a3d] transition hover:-translate-y-0.5 hover:bg-cyan-300">
            Contact our team <span className="ml-2" aria-hidden="true">-&gt;</span>
          </Link>
        </div>
      </section>
    </Layout>
  )
}

export default Services
